module.exports = __webpack_public_path__ + "media/common/statics/lesson_icon/5-788b2be52dbcdf4babffa7864621e8e4.png";